import { DatePipe } from '@angular/common';
import { Component, OnInit, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChatbotConfig } from '@shared/index';
import dayjs from 'dayjs';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { BotService } from 'src/app/shared/services/bot.service';

@Component({
  selector: 'app-bot-memory-browser-filter',
  templateUrl: './bot-memory-browser-filter.component.html',
  styleUrls: ['./bot-memory-browser-filter.component.scss'],
  imports: [DatePipe, FormsModule, DatePickerModule, ButtonModule]
})

export class BotMemoryBrowserFilterComponent implements OnInit {
  public readonly botConfig = input.required<ChatbotConfig>();
  public readonly initialDateRange = input<Date[] | undefined>(undefined);
  public daysWithData: { _id: string, count: number }[] = [];
  public selectedDateRange: Date[] | undefined = undefined;
  public multiCopyFromDate: dayjs.Dayjs | undefined = undefined;
  public multiCopyToDate: dayjs.Dayjs | undefined = undefined;
  public deleteCount: number = 0;
  private readonly daysWithDataSet: Set<string> = new Set<string>();

  constructor(private bot: BotService) { }

  public startEqualsEnd() {
    return this.multiCopyFromDate == this.multiCopyToDate;
  }

  public async ngOnInit() {
    if (this.initialDateRange()) {
      this.selectedDateRange = this.initialDateRange();
      this.onMultiCopyDateSelection(this.selectedDateRange);
    }
    const res = await this.bot.getHistoryInfo(this.botConfig()._id);
    if (res.status == 'ok') {
      this.daysWithData = res.items;
      this.daysWithData.forEach(d => this.daysWithDataSet.add(dayjs(d._id).format('YYYY-MM-DD')));
    }
    void this.updateDeleteCount();
  }

  public hasDataForDate(date: { year: number, month: number, day: number }): boolean {
    const dateKey = dayjs(new Date(date.year, date.month, date.day)).format('YYYY-MM-DD');
    return this.daysWithDataSet.has(dateKey);
  }

  public async updateDeleteCount() {
    const deleteCount = await this.bot.countHistoryItemsByFilter(this.botConfig()._id, {
      fromDate: this.multiCopyFromDate,
      toDate: this.multiCopyToDate
    });

    if (deleteCount.status == 'ok') {
      this.deleteCount = deleteCount.count;
    }
  }

  public onMultiCopyDateSelection(date: Date[] | undefined | null) {
    if (date?.[0] && date[1]) {
      this.multiCopyFromDate = dayjs(date[0]).startOf('day');
      this.multiCopyToDate = dayjs(date[1]).endOf('day');
      void this.updateDeleteCount();
    }
  }
}
